import { IsoCountryCode } from "./user";

export interface ISystem {
	commonName: string;
	name: string;
	logoType: string;
	countryCode: IsoCountryCode;
	mode: string;
	syncConsent: boolean;
}

export class System {
	readonly commonName: string;
	readonly name: string;
	readonly logoType: string;
	readonly countryCode: IsoCountryCode;
	readonly mode: string;
	readonly syncConsent: boolean;
	constructor(values: ISystem) {
		this.commonName = values.commonName;
		this.name = values.name;
		this.logoType = values.logoType;
		this.countryCode = values.countryCode ?? IsoCountryCode.SE;
		this.mode = values.mode;
		this.syncConsent = values.syncConsent;
	}

	haveMode(modesToCheck: systemMode[]) {
		if (!this.mode) {
			return false;
		}
		const modeList = this.mode.split(",").map((mode) => systemMode[mode as keyof typeof systemMode]);

		return modeList.some((mode) => modesToCheck.some((modeToCheck) => modeToCheck === mode));
	}
}

export enum systemMode {
	Undefined = 0,
	/// <summary>
	/// "Time"/"2.0". (1)
	/// </summary>
	Time = 1 << 0,
	/// <summary>
	/// Full payroll system. (2)
	/// </summary>
	Salary = 1 << 1,
	/// <summary>
	/// Booking. (4)
	/// </summary>
	Booking = 1 << 2,
	/// <summary>
	/// Caddie. (16) NOTE: OBSOLETED!
	/// </summary>
	Caddie = 1 << 4,
	/// <summary>
	/// Checkout. (32)
	/// </summary>
	Checkout = 1 << 5,
	/// <summary>
	/// Tip. (512)
	/// </summary>
	Tip = 1 << 9,
	/// <summary>
	/// Schedule systems: currently for Norway where some systems are not full salary systems, but with more functionality than time systems. (2048)
	/// </summary>
	Schedule = 1 << 11,
	/// <summary>
	/// Locked system: e.g. our customer hasn't payed the invoice. Clear some permissions. (4096)
	/// </summary>
	Locked = 1 << 12,
	/// <summary>
	/// Conference Booking, currently only for sending to NAV
	/// </summary>
	KB = 1 << 13,
	/// <summary>
	/// A system with access to other systems in a corporation
	/// </summary>
	Corporate = 1 << 14,
	/// <summary>
	/// Air
	/// </summary>
	Air = 1 << 15,
	/// <summary>
	/// Readonly system: e.g. our cusstomer only pay for read access. Clear all permissions except get, getall and view flags
	/// </summary>
	ReadOnly = 1 << 16,
	// Next values should be powers of 2; the shift operator (1 << 7, 1 << 8, etc) can be used.
}
